import React, {Component} from 'react';

import { bf } from './bf';
import { ic } from './ic';
import { iv } from './iv';
import { ip } from './ip';
import { cp } from './cp';
import { cf } from './cf';
import { ce } from './ce';

import cPdtCtgDtl from './cPdtCtgDtl';

export default class iPdtCtgDtl extends cPdtCtgDtl {
    
  $id_stgs = {
    b_useCm60: false,
  };

  constructor(props) {
    super(props);
    this.state = cf.myRN_crt_stss(
        this.$cd_stss,
        this.$id_stss
    );
  }

  $id_stss = {
  };

  $ilp_loads = () => [
  ];

  $ilp_upds = () => [
  ];

  render(){
    return (
      <ce.RootDtl
        key={-1}
        b_logo={false}
        b_alwEdit={false}
        b_rhtVsb={bf.i(global.c?.state.sgcd_pageCmns?.userc410, ['80']) ? true : false}
        rhtPfx={null}
        onRhtPrs={null}
        b_entBtnVsb={true}
        n_bdyW={ic.gn_maxBdyW}
        d_hdrs={{
          pfx: iv._get_hdrPfx('商品分類情報'),
          d_leftBtns: iv._get_leftBtns(global.c?.state.sgc_pageRole, cf.myNV_get_name(), global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName]),
          d_subMenus: {
            b_vsb: false,
          }
        }}
        d_bdys={{
          ld_defss: [
            {
              type:'Inp',
              b_vsb:true,
              b_edt:(bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit'])) ? true : false,
              state:'s_cm5tc310',
              pfx:'商品分類名',
              b_mln:false,
            },
            {
              type:'Inp',
              b_vsb:true,
              b_edt:(bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit'])) ? true : false,
              state:'s_cm5tcx10',
              pfx:'表示順',
              b_mln:false,
            },
            {
              type:'Pck',
              b_vsb:(bf.i(global.c?.state.sgcd_pageCmns?.userc410, ['80'])) ? true : false,
              b_edt:(bf.i(global.c?.state.sgcd_pageModes[global.c?.state.sgc_pageName], ['new', 'edit'])) ? true : false,
              state:'s_cm5tcz10',
              pfx:'表示の有無',
              ini: '10',
              ld_itemss: [
                {key:'10', pfx: '表示する'},
                {key:'0', pfx: '表示しない'},
              ],
              b_setValOnChg:false,
            },
          ],
        }}
      />
    );
  };
};
